__turbopack_context__.v({
  "collapseIntoIcon": "UploadedBatchOfferPill-module__bMXesq__collapseIntoIcon",
  "pushOut": "UploadedBatchOfferPill-module__bMXesq__pushOut",
  "uploadedBatchOfferPillCollapseIntoIcon": "UploadedBatchOfferPill-module__bMXesq__uploadedBatchOfferPillCollapseIntoIcon",
  "uploadedBatchOfferPillFade": "UploadedBatchOfferPill-module__bMXesq__uploadedBatchOfferPillFade",
  "uploadedBatchOfferPillFadeOut": "UploadedBatchOfferPill-module__bMXesq__uploadedBatchOfferPillFadeOut",
  "uploadedBatchOfferPillPushOut": "UploadedBatchOfferPill-module__bMXesq__uploadedBatchOfferPillPushOut",
});
